import ProjectCommons from "../project-commons";
import Header from "../header";
import SearchAutocomplete from "../search-autocomplete";
import {iOS, isMobileDevice, setSearchTypeValue, toggleOnTarifasSubidaItem} from "../utils.esm";
import {customGa} from "../ga-custom";
import {Modal} from 'bootstrap/js/index.esm';

class PricingPage {
    constructor() {
        console.log('init PricingPage');

        if(!window) return;

        new ProjectCommons();
        this.header = new Header();
        this.modalSubidasProductCategoryInfo = undefined;

        this.autocomplete = new SearchAutocomplete('body', '#main-search-nombre');

        new SearchAutocomplete('#searchModal', '#main-search-nombre');

        setSearchTypeValue();

        if(!isMobileDevice) toggleOnTarifasSubidaItem();

        const Input = document.querySelector('input[name="[send]"]');
        if(Input) {
            document.querySelector('input[name="[send]"]').addEventListener('click', () => {
                document.querySelectorAll('#Form input[type="text"], #Form input[type="email"], #Form textarea').forEach((value) => {
                    // noinspection JSUnresolvedReference
                    if (value.validationMessage !== "") {
                        // noinspection JSUnresolvedReference
                        customGa('formularioo', 'formularioKO', value.validationMessage);
                        return false;
                    }
                });
            });
        }
    }

    openProductsCategoryModal(event, description) {
        if(isMobileDevice && iOS()) document.body.classList.add('ios-fix');
        document.querySelector('#modalSubidasProductCategoryInfo .product-category-description').innerHTML = description;

        this.modalSubidasProductCategoryInfo = new Modal(document.querySelector('#modalSubidasProductCategoryInfo'));
        this.modalSubidasProductCategoryInfo.show();
    }

    reoreProductCategory(element, selector, accordion = false) {
        if(!isMobileDevice) return;
        const target = element.closest(selector);
        if(accordion) {
            document.querySelectorAll(selector).forEach(el => el.classList.remove('toggle-on'));
            target.classList.add('toggle-on');
        } else {
            if(target.classList.contains('toggle-on')) target.classList.remove('toggle-on');
            else target.classList.add('toggle-on');
        }
    }

}
window.pricingPage = new PricingPage();